import * as React from 'react';

class State {
}

class Props {
}

export default class Dashboard extends React.Component<Props, State> {
    render() {
        // tslint:disable-next-line:jsx-wrap-multiline
        return <div id="dashboard">
          <div className="banner">
              <h1>Coming Soon</h1>
              <h4>Page Under Construction</h4>
          </div>
        </div>;
    }
}
/*
<div className="banner">
    <h1>Welcome</h1>
    <h3>This site is a mockup only!</h3>
    <p>In most cases I used data captured from a real probe but some parts may be mock generated data.</p>
    <p>To begin, head to the top-left "hamburger" menu to make a screen selection. There are blue hyperlinks to the following mocked up pages:</p>
    <ul>
        <li>Census</li>
        <li>Assets</li>
        <li>Transaction Log</li>
        <li>Alarm Log</li>
        <li>Alarm Templates</li>
        <li>Global Configuration</li>
    </ul>
    <p>Be sure to check out some working features such as the column selectors in Census page, and the Group By toggles in the Alarm and Transaction Log.</p>
</div>
*/



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/dashboard.tsx